import { Story } from '../../services';
import { StoryTabType } from '../models';
import { isAdminLayout } from './isAdminLayout';

interface StoryTabItemsLinkProps {
  story: Story;
}

export const getStoryTabItemsLink = ({ story }: StoryTabItemsLinkProps) => {
  const { id, settings } = story;

  const {
    includeInMixTab,
    includeInMixTab2,
    includeInMixTab3,
    includeInMixTab4,
    includeInMixTab5,
  } = settings;

  const getStoryTab = () => {
    switch (true) {
      case includeInMixTab:
        return StoryTabType.storyTab1;
      case includeInMixTab2:
        return StoryTabType.storyTab2;
      case includeInMixTab3:
        return StoryTabType.storyTab3;
      case includeInMixTab4:
        return StoryTabType.storyTab4;
      case includeInMixTab5:
        return StoryTabType.storyTab5;
      default:
        return 'storyTab'; // * default path '/:storyTab/:storyId/items'
    }
  };

  return `/${isAdminLayout() ? 'admin/storyTab' : getStoryTab()}/${id}/items`;
};
